import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HiViewGrid, HiSpeakerphone, HiChartBar, HiLogout } from './Icons';
import { useAuth } from '../contexts/AuthContext';
import { getMe } from '../services/api';
import './CustomerLayout.css';

interface CustomerLayoutProps {
  children: React.ReactNode;
}

const CustomerLayout: React.FC<CustomerLayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, displayName: contextDisplayName } = useAuth();
  const [displayName, setDisplayName] = useState<string | null>(contextDisplayName);

  useEffect(() => {
    if (contextDisplayName) {
      setDisplayName(contextDisplayName);
      return;
    }
    getMe()
      .then((res) => {
        if (res.success && res.data) {
          const name = res.data.business_name?.trim()
            ? res.data.business_name
            : (res.data.customer_name ?? '');
          setDisplayName(name || null);
        }
      })
      .catch(() => {});
  }, [contextDisplayName]);

  const handleLogout = () => {
    logout();
    navigate('/customer/login');
  };

  const isActive = (path: string) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div className="customer-layout">
      <aside className="customer-sidebar">
        <div className="customer-sidebar-header">
          <h2>{displayName ? `Hi ${displayName}` : 'TappyTray Customer'}</h2>
        </div>
        <nav className="customer-nav">
          <Link
            to="/customer/dashboard"
            className={`nav-link ${isActive('/customer/dashboard') ? 'active' : ''}`}
          >
            <HiViewGrid size={20} /> Dashboard
          </Link>
          <Link
            to="/customer/promotions"
            className={`nav-link ${isActive('/customer/promotions') ? 'active' : ''}`}
          >
            <HiSpeakerphone size={20} /> My Promotions
          </Link>
          <Link
            to="/customer/statistics"
            className={`nav-link ${isActive('/customer/statistics') ? 'active' : ''}`}
          >
            <HiChartBar size={20} /> Statistics
          </Link>
        </nav>
        <div className="customer-sidebar-footer">
          <button onClick={handleLogout} className="logout-button">
            <HiLogout size={20} /> Logout
          </button>
        </div>
      </aside>
      <main className="customer-main">
        <header className="customer-header">
          <h1>Promotions & Stats</h1>
        </header>
        <div className="customer-content">{children}</div>
      </main>
    </div>
  );
};

export default CustomerLayout;
